export default {
  v3SubmitErrBtnViewOrder: '주문 보기',
  v3SubmitErrBtnBackHome: '홈으로',
  v3SubmitErrBtnRetry: '재시도',
  v3SubmitErrBtnRelogin: '다시 로그인',
  v3SubmitErrBtnSwitchPay: '결제 방식 변경',
  v3SubmitErrBtnReorder: '다시 주문',
  v3SubmitErrBtnSwitchServer: '서버 변경',
  v3SubmitErrBtnViewOrderStatus: '주문 상태',
  v3SubmitErrBtnBackStore: '상점으로 돌아가기',
  v3SubmitErrBtnGoUpdate: '업데이트',
  v3SubmitErrBtnResubscribe: '다시 구독',
  v3SubmitErrTipUpdateApp: '앱스토어에서 업데이트하세요',
  v3SubmitErrTipRelogin: '다시 로그인해 주세요',

  v3SubmitErrMsg120009: '주문이 처리됐어요. 게임 내 백팩을 확인하세요.',
  v3SubmitErrMsg120003: '상품 정보 오류 – 다시 선택하세요.',
  v3SubmitErrMsg120016: '요청이 너무 잦아요. 몇 초 후 다시 시도하세요.',
  v3SubmitErrMsg120025: '요청 매개변수가 이상합니다. 다시 로그인 후 시도하세요.',
  v3SubmitErrMsg121012: '결제 채널을 일시적으로 사용할 수 없어요. 다른 방법을 시도하세요.',
  v3SubmitErrMsg120012: '네트워크가 불안정해요. 연결을 확인하고 다시 시도하세요.',
  v3SubmitErrMsg120002: '게임 캐릭터가 감지되지 않았어요. 먼저 캐릭터를 생성하세요.',
  v3SubmitErrMsg121019: '주문 정보 오류 – 새로 주문하세요.',
  v3SubmitErrMsg120024: '사전등록 선물을 이미 수령했어요. 중복 작업 불필요.',
  v3SubmitErrMsg120000: '로그인이 만료됐어요. 다시 로그인하세요.',
  v3SubmitErrMsg120014: '주문번호가 유효하지 않아요. 새로 주문하세요.',
  v3SubmitErrMsg121001: '게임 충전에 실패했어요. 잠시 후 다시 시도하거나 고객센터에 문의하세요.',
  v3SubmitErrMsg120015: '결제 금액이 이상합니다. 상품을 다시 선택하세요.',
  v3SubmitErrMsg120001: '서버가 일치하지 않아요. 올바른 서버로 전환하세요.',
  v3SubmitErrMsg120020: '결제 채널 오류 – 다른 방법을 시도하세요.',
  v3SubmitErrMsg120010: '게임 충전 기능이 일시적으로 중단됐어요. 나중에 다시 시도하세요.',
  v3SubmitErrMsg120006: '금액 검증 실패 – 다시 선택하세요.',
  v3SubmitErrMsg121010: '샌드박스 환경 충전 요청이 유효하지 않아요. 정식 버전을 사용하세요.',
  v3SubmitErrMsg120017: '주문번호가 중복됐어요. 이미 결제했는지 확인하세요.',
  v3SubmitErrMsg120022: '결제 콜백 검증 실패 – 나중에 다시 시도하세요.',
  v3SubmitErrMsg121000: '시스템이 바빠요. 나중에 다시 시도하세요.',
  v3SubmitErrMsg120011: '상품 ID 오류 – 다시 선택하세요.',
  v3SubmitErrMsg121015: '결제 금액 검증 실패 – 새로 주문하세요.',
  v3SubmitErrMsg120004: '현재 결제 채널이 열려 있지 않아요. 다른 방식을 선택하세요.',
  v3SubmitErrMsg120005: '결제 채널이 점검 중이에요. 다른 방법을 사용하세요.',
  v3SubmitErrMsg120007: '플랫폼 ID 오류 – 다시 로그인하세요.',
  v3SubmitErrMsg120008: '요청 매개변수가 부족해요. 다시 제출하세요.',
  v3SubmitErrMsg120013: '개발사 주문번호 오류 – 새로 주문하세요.',
  v3SubmitErrMsg120018: '결제가 리스크 관리에 차단됐어요. 고객센터에 문의하세요.',
  v3SubmitErrMsg120019: '패키지 이름 검증 실패 – 공식 버전을 사용하세요.',
  v3SubmitErrMsg120021: '상품 ID 검증 실패 – 다시 선택하세요.',
  v3SubmitErrMsg120023: '사전등록 선물 지급 오류 – 나중에 확인하세요.',
  v3SubmitErrMsg120026: '계정이 존재하지 않아요. 계정 상태를 확인하세요.',
  v3SubmitErrMsg120030: '상품 총 재고가 부족해요. 다른 상품을 선택하세요.',
  v3SubmitErrMsg120031: '이 상품의 구매 제한 수량을 초과했어요. 조정하세요.',
  v3SubmitErrMsg120032: '게임 버전이 너무 오래됐어요. 최신 버전을 다운로드하세요.',
  v3SubmitErrMsg120080: '대리 결제가 리스크 관리에 의해 제한됐어요. 자체 결제 방식을 사용하세요.',
  v3SubmitErrMsg120081: '대리 결제가 리스크 관리에 의해 지연됐어요. 나중에 결과를 확인하세요.',
  v3SubmitErrMsg121002: '주문 캐시가 유효하지 않아요. 새로 주문하세요.',
  v3SubmitErrMsg121003: '충전 구성이 존재하지 않아요. 고객센터에 문의하세요.',
  v3SubmitErrMsg121004: '확장 매개변수가 부족해요. 다시 제출하세요.',
  v3SubmitErrMsg121005: '캐시 쓰기 실패 – 나중에 다시 시도하세요.',
  v3SubmitErrMsg121006: '캐시 읽기 실패 – 나중에 다시 시도하세요.',
  v3SubmitErrMsg121007: '충전 유형 구성 오류 – 고객센터에 문의하세요.',
  v3SubmitErrMsg121011: 'Apple 채널에서 새 필드가 감지됐어요. 앱을 업데이트하세요.',
  v3SubmitErrMsg121013: '갱신 주문이 존재하지 않아요. 다시 구독하세요.',
  v3SubmitErrMsg121014: '충전 매개변수 복호화 실패 – 다시 제출하세요.',
  v3SubmitErrMsg121017: '이 주문은 환불됐어요. 고객센터에 문의하세요.',
  v3SubmitErrMsg121018: '구독이 만료됐어요. 다시 구독하세요.',
  v3SubmitErrMsg121020: '주문이 취소됐어요. 새로 주문하세요.',
  v3SubmitErrMsg121021: 'Google API 오류 – 나중에 다시 시도하세요.',
  v3SubmitErrMsg121022: '액세스 토큰 획득 실패 – 다시 로그인하세요.',
  v3SubmitErrMsg121023: '주문 상태 이상 – 입금 상태를 확인하세요.',
  v3SubmitErrMsg121024: '주문 확인 실패 – 나중에 다시 시도하세요.'
};
